import React, { useEffect, useState } from 'react';
import { useSyncronyGenerateTokenQuery } from "@/redux/apiSlices/synchronyApi";

const SynchronyPayment = ({ pageType = "PDP", displayPrice = 999.99 }) => {
  const partnerId = 'PI10000828';
  const price = displayPrice;
  const priceFormatted = price.toFixed(2);

  const [transactionToken, setTransactionToken] = useState(null);

  const {
    data: synchronyData,
    isSuccess: isTokenSuccess,
  } = useSyncronyGenerateTokenQuery();

  useEffect(() => {
    if (isTokenSuccess && synchronyData?.data?.transactionToken) {
      setTransactionToken(synchronyData.data.transactionToken);
    }
  }, [isTokenSuccess, synchronyData]);

  // Load UniFi widget config and script
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    if (!document.getElementById("syfConfigScript")) {
      const configScript = document.createElement("script");
      configScript.id = "syfConfigScript";
      configScript.innerHTML = `
        var syfWidgetObject = {
          syfPartnerId: "${partnerId}",
          flowType: "PDP",
          initialAmount: "${priceFormatted}"
        };
      `;
      document.head.appendChild(configScript);
    }

    if (!document.getElementById("syfMPPScript")) {
      const script = document.createElement("script");
      script.id = "syfMPPScript";
      script.src = "https://spdpone.syfpos.com/mpp/UniFi.js";
      script.async = true;
      script.onload = () => console.log("✅ UniFi.js loaded");
      script.onerror = () => console.error("❌ Failed to load UniFi.js");
      document.head.appendChild(script);
    }

  }, [partnerId, pageType, priceFormatted]);

  const handlePrequalifyClick = () => {
    window?.syfMPP?.mppFromAnyWhere?.(price);
  };

  const openPaymentModal = () => {
    if (!transactionToken) return alert("Transaction token is not ready.");
    if (!window?.syfMPP?.calldBuyProcess) return alert("UniFi modal is not ready. Script may still be loading.");

    const payload = {
      transactionToken,
      processInd: 3,
      tokenId: transactionToken,    
      syfPartnerId: partnerId,       
      clientTransId: `txn-${Date.now()}`,     
      custZipCode: "10001",
      custAddress1: "123 MAIN ST",
      custCity: "NEW YORK",
      custState: "NY",
      transAmount1: priceFormatted,

      custFirstName: "John",
      custLastName: "Doe",
      emailAddress: "john@example.com",
      phoneNumber: "5555551234",
      
    };

    console.log("Sending to SYF modal:", payload);
    window.syfMPP.calldBuyProcess(null, payload);
  };

  const waitForModal = (tries = 0) => {
    if (tries > 5) return alert("Modal still not ready after 1.5s");

    if (window?.syfMPP?.calldBuyProcess) {
      openPaymentModal();
    } else {
      setTimeout(() => waitForModal(tries + 1), 300);
    }
  };

  return (
    <div>
      {/* <div id="product-content">Price: {price}</div> */}
      <div className="sync-price" style={{ margin: '1rem 0' }} />

      {/* <button onClick={handlePrequalifyClick}>Prequalify Now</button>
      <button onClick={waitForModal} style={{ marginLeft: '1rem' }}>
        Pay Now with UniFi
      </button> */}
    </div>
  );
};

export default SynchronyPayment;
